import React from 'react';
import { sdcLeadershipEmployeeColumnList } from '../../constants/MockData';
import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip
} from '@material-ui/core';
import { API_URL } from '../../constants/api';
import CancelIcon from '@material-ui/icons/Cancel';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { apiBatchRequest, apiPost } from '../../utils/api_service';
import SaveIcon from '@material-ui/icons/Save';
import { ShowToast, toastType } from '../../utils/toast-service';
import { isGridFormValid, IsSectionVisible, UpdateColumnWithConfiguration, with2DecimalsPoints } from '../../utils/helper';
import GridTable from '../common/Table/Table';
import { DateFormat, SECTIONS } from '../../constants/appConstants';
import ConfirmDialog from '../common/Dailogbox/confirmDailog';
import _ from 'lodash';
import moment from 'moment';

// Component is used to get/set Budgeted % of Datacenter Leadership employees
export default class ConfigureSDCBudgetedPercentEmployee extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      confirmMessage: null,
      validationMessage: [],
      employeeMasterData: [],
      sdcLeadershipEmployeeData: [],
      pmaTitleMasterData: [],
      isInAddMode: false,
      isDelete: false,
      showWarningMessage: false,
      configuration: [],
      selectedEditRowId: undefined,
      isEditEnable: true,
      updateData: {
        sdcBudgetedPercentConfigurationId: 0,
        employeeId: 0,
        pmaTitleId: 0,
        budgetedPercent: 0,
        preferredName: null,
        pmaTitle: null,
        startDate: null,
        endDate: null
      },
      sdcLeadershipEmployeeColumns: _.cloneDeep(sdcLeadershipEmployeeColumnList)
    };
  }

  /**
     *
     */
  componentDidMount() {
    this.getRequiredData();
  }

  /**
* return master data from
*/
  getRequiredData = () => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Employee.GetEmployeeMasterData,
        key: 'employeeMasterData'
      },
      {
        url: API_URL.Users.GetSDCBudgetedPercentConfiguration,
        key: 'sdcLeadershipEmployeeData'
      },
      {
        url: API_URL.Users.GetPmaTitles,
        key: 'pmaTitleMasterData'
      }

    ])
      .then(({ sdcLeadershipEmployeeData, employeeMasterData, pmaTitleMasterData }) => {
        this._asyncRequest = null;
        if (employeeMasterData.success !== true) {
          ShowToast(
            'Something went wrong',
            toastType.ERROR,
            5000,
            500,
            'Server error'
          );
        }
        this.setState({
          employeeMasterData: employeeMasterData.data.filter(x => (x.marketId === 6 || x.marketId === 7 ||
            ((x.otherMarketId || '').split('|').indexOf((6 || '').toString()) !== -1) ||
            ((x.otherMarketId || '').split('|').indexOf((7 || '').toString()) !== -1))) || [],
          pmaTitleMasterData: pmaTitleMasterData.data || [],
          sdcLeadershipEmployeeData: sdcLeadershipEmployeeData.data || [],
          configuration: sdcLeadershipEmployeeData.config || [],
          reloadTable: !this.state.reloadTable
        });
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  /**
   * add new record in grid table
   * @returns
   */
  AddNewRecord = () => {
    if (this.state.isInAddMode === true) {
      ShowToast('You can add one row at a time!', toastType.WARNING, 5000, 500);
      return false;
    }
    const sdcLeadershipEmployeeColumns = _.cloneDeep(sdcLeadershipEmployeeColumnList);
    const rowNew = {
      sdcBudgetedPercentConfigurationId: 0,
      employeeId: 0,
      pmaTitleId: 0,
      budgetedPercent: 0,
      preferredName: null,
      pmaTitle: null,
      statusId: 1,
      startDate: null,
      endDate: null
    };

    this.setState({
      isInAddMode: true,
      selectedEditRowId: { key: 'sdcBudgetedPercentConfigurationId', value: 0 },
      reloadTable: !this.state.reloadTable,
      updateData: rowNew,
      sdcLeadershipEmployeeColumns
    });
  };

  /**
   * cancel row open for add mode
   */
  cancelAddMode = () => {
    this.setState({
      selectedEditRowId: undefined,
      isInAddMode: false,
      updateData: undefined,
      reloadTable: !this.state.reloadTable
    });
    this.getRequiredData();
  };

  /**
   * cancel row open for edit mode
   */
  cancelEditMode = () => {
    this.setState({
      selectedEditRowId: undefined,
      isInAddMode: false,
      updateData: undefined,
      reloadTable: !this.state.reloadTable
    });
    this.getRequiredData();
  };

  // Open record into Edit mode
  EditRecord = (cellInfo) => {
    const sdcLeadershipEmployeeColumns = _.cloneDeep(sdcLeadershipEmployeeColumnList);

    this.setState({
      sdcLeadershipEmployeeColumns,
      selectedEditRowId: {
        key: 'sdcBudgetedPercentConfigurationId',
        value: cellInfo.sdcBudgetedPercentConfigurationId
      },
      isInAddMode: false,
      updateData: cellInfo,
      reloadTable: !this.state.reloadTable
    });
  }

  // Handle Delete button click event
  onClickHandle(e) {
    if (this.state.isDelete) {
      this.onDeleteHandle(e);
    }
  }

  // Open Dialog box for confirmation of Delete operation
  deleteRecord(cellInfo) {
    this.setState({
      isDelete: true,
      showWarningMessage: true,
      confirmMessage: 'Do you want to delete this record ?',
      updateData: cellInfo
    });
  };

  // Handle delete action post confirmation
  onDeleteHandle(e) {
    const newParam = this.state.updateData;
    if (e) {
      newParam.statusId = 11;
      apiPost({
        url: API_URL.Users.UpdateSDCBudgetedPercentConfiguration,
        postBody: newParam
      }
      ).then(({ data: response }) => {
        if (response.success === true) {
          ShowToast('Record deleted successfully.',
            toastType.SUCCESS,
            5000,
            500
          );

          this.setState({
            updateData: undefined,
            selectedEditRowId: undefined,
            reloadTable: !this.state.reloadTable,
            isDelete: false,
            showWarningMessage: false
          });
          this.getRequiredData();
          this.forceUpdate();
        } else {
          ShowToast(
            response.message,
            toastType.ERROR,
            5000,
            5000
          );
        }
      });
    } else {
      this.setState({ showWarningMessage: false, confirmationMessage: '' });
    }
  }

  // check if Edit icon should be display
  isEditIconVisible = (cellInfo) => {
    const { sdcLeadershipEmployeeData } = this.state;
    if (IsSectionVisible(SECTIONS.DATA_CENTER_CONFIGURATION, SECTIONS.CONFIGURE_SDC_LEADERSHIP_EMPLOYEE, SECTIONS.ADD_EDIT)) {
      const sdcData = sdcLeadershipEmployeeData.filter(x => x.preferredName === cellInfo.preferredName && x.pmaTitle === cellInfo.pmaTitle);
      // console.log(sdcData);
      if (cellInfo !== undefined &&
        (cellInfo.endDate === null ||
          cellInfo.endDate === '0001-01-01T00:00:00' || moment(cellInfo.endDate).format(DateFormat) >= moment().format(DateFormat))) {
        return true;
      }
      if ((sdcData || []).length > 1) {
        const latest = sdcData.reduce(function (r, a) {
          return moment(r.startDate).format(DateFormat) > moment(a.startDate).format(DateFormat) ? r : a;
        });
        if (latest.sdcBudgetedPercentConfigurationId !== cellInfo.sdcBudgetedPercentConfigurationId) {
          return false;
        }
      }
    }
    return false;
  }

  /**
  * render action column on grid table
  * @param {*} cellInfo
  * @param {*} isInAddMode
  * @returns
  */
  renderActionColumn = (cellInfo, key, isInAddMode) => {
    return (
      <>
        {this.state.selectedEditRowId !== undefined &&
          cellInfo.sdcBudgetedPercentConfigurationId === this.state.selectedEditRowId.value
          ? (
            <>
              <Tooltip title="Save Record">
                <IconButton
                  aria-label={'refreshData'}
                  size="small"
                  onClick={() => { }}
                >
                  <SaveIcon
                    fontSize="small"
                    size="small"
                    onClick={this.saveUpdatedRecord

                    }
                  />
                </IconButton>
              </Tooltip>
              <Tooltip title="Cancel">
                <IconButton
                  aria-label={'refreshData'}
                  size="small"
                  onClick={this.cancelEditMode}
                >
                  <CancelIcon fontSize="small" size="small" />
                </IconButton>
              </Tooltip>
            </>
          )
          : <>
            { this.isEditIconVisible(cellInfo) && (
              <Tooltip title="Edit Record">
                <IconButton
                  aria-label={'refreshData'}
                  size="small"
                  onClick={() => {
                    if (this.state.isInAddMode === true || this.state.selectedEditRowId !== undefined) {
                      ShowToast('You can add/Edit one row at a time!', toastType.WARNING, 5000, 500);
                      return false;
                    } else {
                      this.EditRecord(cellInfo);
                    }
                  }}
                >
                  <EditIcon fontSize="small" size="small" />
                </IconButton>
              </Tooltip>)}
            { (IsSectionVisible(SECTIONS.DATA_CENTER_CONFIGURATION, SECTIONS.CONFIGURE_SDC_LEADERSHIP_EMPLOYEE, SECTIONS.ADD_EDIT)) &&
              (cellInfo !== undefined && cellInfo.startDate !== undefined && cellInfo.startDate !== null && moment(cellInfo.startDate).format('YYYY/MM/DD') >= moment().format('YYYY/MM/DD')) &&
              (<Tooltip title="Delete">
                <IconButton aria-label={'refreshData'} size="small" onClick={() => {
                  this.deleteRecord(cellInfo);
                }}
                >
                  <DeleteIcon fontSize="small" size="small" />
                </IconButton>
              </Tooltip>)
            }
          </>
        }
      </>
    );
  };

  /**
   * is Form Valid
   */
  isValidForm = () => {
    let IsValid = true;
    const { updateData, sdcLeadershipEmployeeColumns } = this.state;
    sdcLeadershipEmployeeColumns.forEach((ele) => {
      isGridFormValid(updateData[ele.key], ele, updateData);
      if (ele.isInErrorState === true) {
        IsValid = false;
      }
    });
    this.setState({ sdcLeadershipEmployeeColumns }, this.forceUpdate());
    return IsValid;
  };

  // Check if duplicate record is exists
  isEmpWithSamePmaTitle = () => {
    const { updateData, sdcLeadershipEmployeeData } = this.state;
    let empExists = sdcLeadershipEmployeeData.find(x => x.employeeId === updateData.employeeId &&
      x.pmaTitleId === updateData.pmaTitleId && x.sdcBudgetedPercentConfigurationId !== updateData.sdcBudgetedPercentConfigurationId &&
      (x.endDate === null || x.endDate === '0001-01-01T00:00:00' || moment(x.endDate).format(DateFormat) > moment().format(DateFormat)));
    if (empExists === undefined) {
      empExists = sdcLeadershipEmployeeData.find(x => x.employeeId === updateData.employeeId &&
        x.pmaTitleId === updateData.pmaTitleId && x.sdcBudgetedPercentConfigurationId !== updateData.sdcBudgetedPercentConfigurationId &&
        (moment(updateData.startDate).format(DateFormat) < moment(x.endDate).format(DateFormat)));
    }
    return empExists !== undefined;
  }

  /**
   * save Updated Record to database
   */
  saveUpdatedRecord = () => {
    const { updateData, sdcLeadershipEmployeeData } = this.state;
    const selectedEmployeeList = sdcLeadershipEmployeeData.filter(x => x.employeeId === updateData.employeeId && x.sdcBudgetedPercentConfigurationId !== updateData.sdcBudgetedPercentConfigurationId &&
      (x.endDate === null || x.endDate === '0001-01-01T00:00:00' || moment(x.endDate).format(DateFormat) > moment().format(DateFormat)));
    const budgetedPercent = with2DecimalsPoints(selectedEmployeeList.reduce((total, obj) => (parseFloat(obj.budgetedPercent) + parseFloat(total)), 0));

    if (!this.isValidForm()) { return false; } else {
      if (this.isEmpWithSamePmaTitle()) {
        ShowToast(
          'Employee: ' + updateData.preferredName + ' is already present with PMA title: ' + updateData.pmaTitle + ' for same date.', toastType.ERROR,
          5000,
          500
        );
        return false;
      } if ((parseFloat(updateData.budgetedPercent) + parseFloat(budgetedPercent)) > 100) {
        ShowToast(
          'Budgeted Percent for Employee: ' + updateData.preferredName + ' exceeds 100.',
          toastType.ERROR,
          5000,
          500
        );
        return false;
      } else {
        const newParam = this.state.updateData;
        newParam.statusId = 1;
        apiPost({
          url: API_URL.Users.UpdateSDCBudgetedPercentConfiguration,
          postBody: newParam
        }
        ).then(({ data: response }) => {
          if (response.success === true) {
            ShowToast(
              this.state.isInAddMode
                ? 'Record added successfully.'
                : 'Record updated successfully.',
              toastType.SUCCESS,
              5000,
              500
            );

            this.setState({
              updateData: undefined,
              selectedEditRowId: undefined,
              reloadTable: !this.state.reloadTable,
              isInAddMode: false
            });
            this.getRequiredData();
            this.forceUpdate();
          } else {
            ShowToast(
              response.message,
              toastType.ERROR,
              5000,
              5000
            );
          }
        });
      }
    }
  };

  /**
 * handle on change
 * @param {*} value
 * @param {*} fieldName
 */
  handleTableEditChange = (value, fieldName) => {
    const { sdcLeadershipEmployeeColumns, sdcLeadershipEmployeeData, pmaTitleMasterData, employeeMasterData } = this.state;
    const param = this.state.updateData;
    const validationMessage = this.state.validationMessage;
    if (fieldName === 'preferredName') {
      const valueOfEmployee = employeeMasterData.find((x) => x.employeeName === value);
      param.employeeId = (valueOfEmployee || {}).employeeId;
      param.preferredName = (valueOfEmployee || {}).employeeName;
      const selectedEmployeeList = sdcLeadershipEmployeeData.filter(x => x.employeeId === param.employeeId &&
        (x.endDate === null || x.endDate === '0001-01-01T00:00:00' || moment(x.endDate).format(DateFormat) > moment().format(DateFormat)));
      const budgetedPercent = with2DecimalsPoints(selectedEmployeeList.reduce((total, obj) => (parseFloat(obj.budgetedPercent) + parseFloat(total)), 0));
      param.budgetedPercent = parseFloat(budgetedPercent) >= 100 ? 0 : parseFloat(with2DecimalsPoints(100 - parseFloat(budgetedPercent)));
    } else if (fieldName === 'pmaTitle') {
      const pmaData = pmaTitleMasterData.find((x) => x.pmaTitle === value);
      param.pmaTitleId = (pmaData || {}).pmaTitleId;
      param[fieldName] = value;
    } else if (fieldName === 'budgetedPercent') {
      param[fieldName] = parseFloat(with2DecimalsPoints(value));
    } else {
      param[fieldName] = value;
    }

    isGridFormValid(value, sdcLeadershipEmployeeColumns.find(x => x.key === fieldName), param);
    const selectedField = sdcLeadershipEmployeeColumns.find((x) => x.key === fieldName);

    if (selectedField.dependentFieldValidation !== undefined && selectedField.dependentFieldValidation.length > 0) {
      selectedField.dependentFieldValidation.forEach(x => {
        if (param[x] !== undefined && param[x] !== '' && param[x] !== null) {
          const ele = sdcLeadershipEmployeeColumns.find((y) => y.key === x);
          isGridFormValid(
            param[x],
            ele,
            param
          );
        }
      });
    }
    this.setState({ updateData: param, validationMessage: (validationMessage || []).filter(x => { return x.key !== fieldName; }) }, () => {
      this.forceUpdate();
    });
  };

  /**
   * render elements to UI
   * @returns UI
   */
  render() {
    const { employeeMasterData, pmaTitleMasterData, configuration, sdcLeadershipEmployeeColumns } = this.state;

    const EditSource = [];
    EditSource.push({
      key: 'employeeMasterData',
      data: employeeMasterData
    },
      {
        key: 'pmaTitleMasterData',
        data: pmaTitleMasterData
      });
    return (
      <>
        {this.state.showWarningMessage && (
          <ConfirmDialog
            IsOpen={this.state.showWarningMessage}
            Message={this.state.confirmMessage}
            OnHandelClick={(isValid) => {
              if (isValid) {
                this.onClickHandle(isValid);
              } else {
                this.onClickHandle(isValid);
              }
            }}
            AgreeText="Yes"
            DisAgreeText="No"
          ></ConfirmDialog>
        )}
        <Table
          aria-labelledby="tableMenuTitle"
          size={'small'}
          aria-label="configuration table"
        >
          <TableHead>
            <TableRow>
              <TableCell
                key={'configureHeader'}
                className="content-header"
                colSpan={2}
              >
                <div className="content-header d-flex">
                  {' '}
                  <div
                    className="col-xs-11"
                    style={{ display: 'inline-block', alignItems: 'center' }}
                  >
                    Configure Datacenter Leadership Employee
                  </div>
                </div>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>
                <GridTable
                  validationMessage={this.state.validationMessage || []}
                  columns={UpdateColumnWithConfiguration(
                    sdcLeadershipEmployeeColumns,
                    configuration,
                    []
                  )}
                  data={this.state.sdcLeadershipEmployeeData}
                  renderActionColumn={this.renderActionColumn}
                  selectedEditRowId={this.state.selectedEditRowId}
                  isInAddMode={this.state.isInAddMode}
                  EditSource={EditSource}
                  handleTableEditChange={this.handleTableEditChange}
                  updateData={this.state.updateData}
                  AddNewRecord={{
                    action: this.AddNewRecord,
                    title: 'Add New Datacenter Leadership Employee',
                    visible: IsSectionVisible(SECTIONS.DATA_CENTER_CONFIGURATION, SECTIONS.CONFIGURE_SDC_LEADERSHIP_EMPLOYEE, SECTIONS.ADD_EDIT)
                  }}
                  isInline={true}
                  reload={this.state.reloadTable}
                ></GridTable>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </>
    );
  }
}
